export default "__VITE_ASSET__DHbSMlJb__"